import { IStage, movSitesV2 } from '@metservicedev/platforms-services-interface';
import { aggregatePaginationResponse } from '@metservicedev/platforms-services-interface/src/utils/asyncGeneratorForPagination';

const getSites = async (stage: IStage, metjwt: string) => {
    const allSites = await aggregatePaginationResponse(
        movSitesV2.http.getAll({
            stage,
            token: metjwt,
        }),
        (data) => data.sites
    );
    console.log(allSites.length);
    return allSites;
};

export default getSites;
